import { render, staticRenderFns } from "./chooseSingleResource.vue?vue&type=template&id=d49f288e&scoped=true"
import script from "./chooseSingleResource.vue?vue&type=script&lang=js"
export * from "./chooseSingleResource.vue?vue&type=script&lang=js"
import style0 from "./chooseSingleResource.vue?vue&type=style&index=0&id=d49f288e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49f288e",
  null
  
)

export default component.exports